import { render, staticRenderFns } from "./pagamentos.vue?vue&type=template&id=ab17159e&scoped=true"
import script from "./pagamentos.vue?vue&type=script&lang=js"
export * from "./pagamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab17159e",
  null
  
)

export default component.exports